import { Button as MuiButton, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(0.5),
  },
  label: {
    textTransform: "none",
  },
}));

export default function Button({
  text,
  size,
  icon,
  color,
  variant,
  onClick,
  type,
  ...other
}) {
  // const {text,size,icon , color, variant, onClick, type,...other} = props
  const classes = useStyles();
  return (
    <MuiButton
      variant={variant || "contained"}
      size={size || "medium"}
      color={color || "primary"}
      type={type}
      onClick={onClick}
      {...other}
      classes={{ root: classes.root, label: classes.label }}
    >
      {text} {icon}
    </MuiButton>
  );
}
